export enum FeatureFlag {
	TESTING_FEATURE_FLAG = 'testing-feature-flag',
	CUSTOM_DOMAIN_FLAG = 'resellers-custom-domain',
	POST_CALL_TEXT_BACK = 'post-call-text-back',
	POST_CALL_ANALYSIS_FLAG = 'post-call-analyis',
	WORKFLOW_AVAILABILITY = 'workflow-availability',
	INTERRUPTION_SENSITIVITY = 'interruption-sensitivity',
	IDLE_MESSAGES_FOR_INACTIVITY = 'idle-messages-for-inactivity',
	KNOWLEDGEBASE_CONTENT_LATENCY_ALERTS = 'knowledgebase-content-latency-alerts',
	API_TOKEN_INTEGRATION = 'api-token-integration',
	INTAKE_BEGINNING_NATURAL = 'intake-beginning-natural',
	GOHIGHLEVEL_INTEGRATION = 'gohighlevel-integration',
	NEW_REGISTRATION_FLOW = 'registration-ui-revamp-v2',
	API_CHAINING = 'api-chaining',
	DASHBOARD_LANGUAGE_PRESET = 'dashboard-language-preset',
	COMPREHENSIVE_WEB_SCRAPING = 'comprehensive-web-scraping',
	REGISTRATION_AND_ONBOARDING_REVAMP = 'registration-and-onboarding-revamp',
	BETA_INBOX = 'beta-inbox',
	TOGGLE_RATE_CALL_SURVEY = 'TOGGLE_RATE_CALL_SURVEY',
}
